import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';
import { SMORG_STUDIO_SPACE_SHARED_CONTENT_BOARD_ENTRY_ROUTE } from '../../services/routes';
import { useGetOrCreateSpaceContentBoardsQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { ActivityObjectType, EntryType, OriginObjectType } from '../../API';
import {
  useCreateSharedContentEntryMutation,
  useGetSpaceQuery,
  useUpdateSharedContentBoardMutation,
} from '../../app/smorgAppSyncGraphQLApi';
import { reportAccountActivitySignalOperation } from '../../operations/user_profile_operations';
import { userFriendlyNameForActivitySignalSelector } from '../../features/user_id/user_id_slice';

const SpaceContentBoardAddCardLink = ({ laneId }) => {
  const { data: space } = useGetSpaceQuery();

  const { data: sharedContentBoards } = useGetOrCreateSpaceContentBoardsQuery();

  const [createSharedContentEntry] = useCreateSharedContentEntryMutation();

  const [updateSharedContentBoard] = useUpdateSharedContentBoardMutation();

  const sharedContentBoard = (sharedContentBoards || []).find((b) =>
    b.lanes.some((l) => l.id === laneId),
  );

  const navigate = useNavigate();

  const friendlyUsername = useSelector(
    userFriendlyNameForActivitySignalSelector,
  );

  const handleCreateSharedContentEntry = async (ev) => {
    ev.preventDefault();
    const input = {
      title: '',
      tags: [],
      parentID: sharedContentBoard.id,
      origin: {
        originObjectType: OriginObjectType.CONTENT_ENTRY,
        originObjectID: '00000000-0000-0000-0000-000000000000',
      },
    };
    const { data: sharedContentEntry } = await createSharedContentEntry(input);

    const updatedBoard = {
      ...sharedContentBoard,
      lanes: sharedContentBoard.lanes.map((lane) => {
        if (lane.id !== laneId) {
          return lane;
        }
        return {
          ...lane,
          entries: [
            ...lane.entries,
            {
              id: uuidv4(),
              entryType: EntryType.CONTENT_ENTRY,
              objectID: sharedContentEntry.id,
            },
          ],
        };
      }),
    };

    await updateSharedContentBoard(updatedBoard);
    reportAccountActivitySignalOperation({
      spaceID: space.id,
      friendlyUsername,
      lastActivityObjectType: ActivityObjectType.SHARED_CONTENT_BOARDS,
      lastActivityObjectID: sharedContentBoard.id,
    });
    navigate(
      formatRoute(SMORG_STUDIO_SPACE_SHARED_CONTENT_BOARD_ENTRY_ROUTE, {
        sharedContentBoardID: sharedContentBoard.id,
        entryId: sharedContentEntry.id,
      }),
    );
  };

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <a
      onClick={handleCreateSharedContentEntry}
      style={{
        color: '#838c91',
        display: 'block',
        padding: '5px 2px',
        marginTop: '10px',
        textDecoration: 'none',
        fontSize: '15px',
        cursor: 'pointer',
      }}>
      + Add new post
    </a>
  );
};

SpaceContentBoardAddCardLink.propTypes = {
  laneId: PropTypes.string.isRequired,
};

export default SpaceContentBoardAddCardLink;
